module.exports = __webpack_public_path__ + "img/news-3.918bf8f.webp";